import { debounce } from 'lodash';
import { fullHeaderHeight } from '../helpers';

class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#results-wrapper');
    this.form = this.querySelector('form');

    document.querySelectorAll('[data-open-predictive]').forEach((opener) =>
      opener.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      }),
    );
    document.querySelectorAll('[data-close-predictive]').forEach((closer) =>
      closer.addEventListener('click', (e) => {
        e.preventDefault();
        this.close();
      }),
    );

    this.input.addEventListener(
      'input',
      debounce((event) => {
        this.onChange(event);
      }, 300).bind(this),
    );
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.hideResults();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(
      `/search/suggest?q=${searchTerm}&section_id=search-results&options[prefix]=last&resources[type]=product,collection&resources[limit]=${
        this?.dataset?.limit ? this?.dataset?.limit : '10'
      }&resources[limit_scope]=each`,
    )
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-search-results').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        if (typeof window?.dAgency?.initProductTile !== 'undefined') {
          this.predictiveSearchResults
            .querySelectorAll('.product-tile__container')
            .forEach((tile) => {
              window.dAgency.initProductTile(tile);
            });
        }
        if (typeof _swat?.initializeActionButtons !== 'undefined') {
          _swat.initializeActionButtons('.predictive-search__results');
        }
        this.predictiveSearchResults.style.maxHeight = '';
        this.predictiveSearchResults.style.height = '';
        this.predictiveSearchResults
          .querySelectorAll('[type="submit"]')
          .forEach((submit) =>
            submit.addEventListener('click', () => this.form.submit()),
          );

        requestAnimationFrame(() => {
          this.showResults();
        });
      })
      .catch((error) => {
        this.hideResults();
        throw error;
      });
  }

  open() {
    if (document.querySelector('.header__container').classList.contains('header__transparent')) {
      document.querySelector('.header__container').classList.add('open-search');
    }
    this.classList.add('open');
    this.input.focus();
  }

  close() {
    if (document.querySelector('.header__container').classList.contains('open-search')) {
      document.querySelector('.header__container').classList.remove('open-search');
    }
    this.classList.remove('open');
    this.input.value = '';
    this.hideResults();
  }

  updateResultsHeight() {
    var maxHeight =
      window.innerHeight - fullHeaderHeight() - this.form.clientHeight - 61;
    if (window.innerWidth > 1024) {
      maxHeight = window.innerHeight - fullHeaderHeight() - this.form.clientHeight;
    }

    if (this.predictiveSearchResults.clientHeight >= maxHeight) {
      this.predictiveSearchResults.style.maxHeight = `${maxHeight}px`;
      this.predictiveSearchResults.style.height = '100dvh';
    } else {
      this.predictiveSearchResults.style.maxHeight = '';
      this.predictiveSearchResults.style.height = 'auto';
    }
  }

  showResults() {
    this.updateResultsHeight();
    this.predictiveSearchResults.classList.add('open');
  }

  hideResults() {
    this.predictiveSearchResults.classList.remove('open');
    setTimeout(() => {
      this.predictiveSearchResults.style.maxHeight = '';
      this.predictiveSearchResults.style.height = '';
      this.predictiveSearchResults.innerHTML = '';
    }, 1000);
  }
}

customElements.define('predictive-search', PredictiveSearch);
